import { Amplify } from 'aws-amplify';

/** Cognito pool used by the CMS (same as legacy `aws-configs.js`). */
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: 'eu-west-1_K1L1Dr9i3',
      userPoolClientId: '39upoqrgro0kenlh0mglilijcm',
    },
  },
});
